// The GridController mark: the cyan bolt on the dark rounded square (the favicon's drawing). Its own module so the
// sign-in entry draws it without the console.

export function BoltMark({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={`shrink-0${className ? ` ${className}` : ''}`} aria-hidden>
      <rect x={0.5} y={0.5} width={31} height={31} rx="4" fill="#11151B" stroke="#3B4656" strokeWidth={1} />
      <path d="M18 3 8 18h7l-2 11 11-16h-7z" fill="#3DD6F5" />
    </svg>
  );
}
